module.exports = __webpack_public_path__ + "static/img/202303251001025713_.6514d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/202303251001025713_.png
// module id = cBaL
// module chunks = 1